export default __webpack_public_path__ + "static/media/moviesHub.263e42da.jpg";